import * as React from 'react';
import { connect } from "react-redux";
import { Redirect, Route } from "react-router";
import { AppRoutes } from '../../core/constants';
import { ApplicationState } from "../../store";

function ProtectedRoute(props: any) {
    const { component: Component, isLoggedIn, ...rest } = props;
    const redirectUrl = AppRoutes.Login;

    return <Route {...rest}
                render={(props) => {
                    if (isLoggedIn) {
                        return <Component {...props} {...rest}/>
                    } else {
                        return <Redirect to={{ pathname: redirectUrl, state: { from: props.location } }} />
                    }
                }} />
}

export default connect(
    (state: ApplicationState) => state.authentication,
    {}
)(ProtectedRoute)